import React from 'react';
import PropTypes from 'prop-types';
import './styles/main';
import { Brandfolder, Collection } from '../../../../../helpers/show_page_helpers';

class Insights extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      currentEvents: {},
      previousEvents: {}
    };

    // current/previous reference timeframe
    this.currentAjaxCalls = [];
    this.previousAjaxCalls = [];
  }

  componentDidMount() {
    this.addTabListener();
  }

  componentWillUnmount() {
    this.removeTabListener();
    this.abortAjaxCalls();
  }

  get previousDates() {
    return {
      start: this.timeAgo(60),
      end: this.timeAgo(30)
    };
  }

  get currentDates() {
    return {
      start: this.previousDates.end,
      end: new Date()
    };
  }

  requestInsights = () => {
    const { currentEvents, previousEvents } = this.state;
    if (typeof currentEvents.total_events !== "number" && !this.activeAjaxCall("current")) {
      this.fetchInsights("current");
    }
    if (typeof previousEvents.total_events !== "number" && !this.activeAjaxCall("previous")) {
      this.fetchInsights("previous");
    }
  }

  addTabListener = () => {
    window.addEventListener(
      `usageAssetTabHover${this.props.asset_key}`,
      this.requestInsights,
      false
    );
  }

  removeTabListener = () => {
    window.removeEventListener(
      `usageAssetTabHover${this.props.asset_key}`,
      this.requestInsights,
      false
    );
  }

  timeAgo(days) {
    return new Date(new Date().setDate(new Date().getDate() - days));
  }

  addAjaxCall(xhr, timeFrame) {
    this[`${timeFrame}AjaxCalls`] = this[`${timeFrame}AjaxCalls`].concat(xhr);
  }

  activeAjaxCall(timeFrame) {
    return !!this[`${timeFrame}AjaxCalls`].find((xhr) => xhr.readyState !== 4);
  }

  abortAjaxCalls() {
    this.currentAjaxCalls.concat(this.previousAjaxCalls).forEach((ajaxCall) => {
      if (ajaxCall.readyState !== 4) { ajaxCall.abort(); }
    });
  }

  fetchInsights(timeFrame) {
    /* eslint-disable no-undef */
    const { asset_key } = this.props;
    const dateRange = (timeFrame === "previous") ? this.previousDates : this.currentDates;
    const request = $.ajax({
      type: "GET",
      url: `${BFG.INSIGHTS_API_URL}/api/v1/events/counts`,
      contentType: "application/json",
      context: this,
      timeFrame,
      timeout: 30000,
      data: {
        source: SOURCE,
        resource_type: "asset",
        resource_key: asset_key,
        start_date: dateRange.start,
        end_date: dateRange.end
      },
      beforeSend(xhr) {
        xhr.setRequestHeader("Authorization", `Bearer ${BF_Token}`);
      },
      success(response) {
        this.setState({ [`${timeFrame}Events`]: response.data });
      },
    });
    this.addAjaxCall(request, timeFrame);
    /* eslint-enable no-undef */
  }

  percentages() {
    const { previousEvents, currentEvents } = this.state;
    if (previousEvents.total_events && currentEvents.total_events) {
      return {
        total_events: this.calculatePercentage('total_events'),
        total_views: this.calculatePercentage('total_views'),
        total_downloads: this.calculatePercentage('total_downloads'),
        total_shares: this.calculatePercentage('total_shares')
      };
    }
    return {};
  }

  calculatePercentage(key) {
    const { previousEvents, currentEvents } = this.state;
    const percentage = ((currentEvents[key] - previousEvents[key]) / previousEvents[key]);
    return Math.round(parseFloat(percentage * 100));
  }

  renderPecentageChange(calculation) {
    if (calculation === undefined) {
      return (
        <div className="percentage-change-none">
          <span>
            {t('Trends')}
          </span>
          <p>{t('calculating...')}</p>
        </div>
      );
    }
    if (calculation === Infinity) {
      return (
        <div className="percentage-change-none">
          <span>
            {t('Trends')}
          </span>
          <p>{t('available in 30 days')}</p>
        </div>
      );
    }
    if (calculation === 0 || Number.isNaN(calculation)) {
      return (
        <div className="percentage-change-none">
          <span>0%</span>
          <p>{t('over the past 30 days')}</p>
        </div>
      );
    }
    if (calculation < 0) {
      return (
        <div className="percentage-change-negative">
          <span className="bff-right-arrow" />
          <span>
            {calculation}
            %
          </span>
          <p>{t('over the past 30 days')}</p>
        </div>
      );
    }
    return (
      <div className="percentage-change-positive">
        <span className="bff-right-arrow" />
        <span>
          {calculation}
          %
        </span>
        <p>{t('over the past 30 days')}</p>
      </div>
    );
  }

  renderScore() {
    const { score, potential } = this.props;
    if (potential > 0) {
      return (
        <span>
          {score}
          <span className="potential-score">
            /
            {potential}
          </span>
        </span>
      );
    }
    // potential has not been calculated
    return score;
  }

  render() {
    const { asset_key } = this.props;
    const collectionSlug = Collection.key ? `/collections/${Collection.slug}` : "";
    const insightsLink = `${BFG.INSIGHTS_URL}/${Brandfolder.slug}${collectionSlug}/assets/${asset_key} `;
    return (
      <React.Fragment>
        <div className="scoring">
          <div className="title-container">
            <p className="scoring-title">{t('Insights from the last 30 days')}</p>
            <button
              className="button primary"
              type="button"
              onClick={() => { window.open(insightsLink, "_blank"); }}
            >
              {t('View Insights')}
            </button>
          </div>
          <div className="scoring-container">
            <div className="asset-score asset-score-desktop">
              <div className="asset-score-result">
                <div>
                  <span>{ this.renderScore() }</span>
                  <span className="bff-score-meter" />
                </div>
                <p>{t('Asset score')}</p>
              </div>
              <a href="https://help.brandfolder.com/hc/en-us/articles/360015524333" target="_blank" rel="noopener noreferrer">
                {t('How is this calculated?')}
              </a>
            </div>
            <div className="score-breakdown">
              <div className="asset-score asset-score-tablet">
                <div className="asset-score-result">
                  <div>
                    <span>{ this.renderScore() }</span>
                    <span className="bff-score-meter" />
                  </div>
                  <p>{t('Asset score')}</p>
                </div>
                <a href="https://help.brandfolder.com/hc/en-us/articles/360015524333" target="_blank" rel="noopener noreferrer">
                  {t('How is this calculated?')}
                </a>
              </div>
              <div className="individual-score asset-views">
                <div>
                  <span>{ this.state.currentEvents.total_views }</span>
                  <p>{ this.state.currentEvents.total_views === 1 ? t('Asset view') : t('Asset views')}</p>
                </div>
                <div className="percentage-change">
                  <span>
                    { this.renderPecentageChange(this.percentages().total_views, t("views")) }
                  </span>
                </div>
              </div>
              <div className="individual-score asset-downloads">
                <div>
                  <span>{ this.state.currentEvents.total_downloads }</span>
                  <p>{ this.state.currentEvents.total_downloads === 1 ? t('Asset download') : t('Asset downloads') }</p>
                </div>
                <div className="percentage-change">
                  <span>
                    { this.renderPecentageChange(this.percentages().total_downloads, t("downloads")) }
                  </span>
                </div>
              </div>
              <div className="individual-score asset-shares">
                <div>
                  <span>{ this.state.currentEvents.total_shares }</span>
                  <p>{ this.state.currentEvents.total_shares === 1 ? t('Asset share') : t('Asset shares') }</p>
                </div>
                <div className="percentage-change">
                  <span>
                    { this.renderPecentageChange(this.percentages().total_shares, t("shares")) }
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

Insights.propTypes = {
  asset_key: PropTypes.string.isRequired,
  score: PropTypes.number,
  potential: PropTypes.number
};

Insights.defaultProps = {
  score: 0,
  potential: 0
};

export default Insights;
